const formatAddress = (address) => {
  if (!address) return "";

  const { city, state, zip, country } = address;

  const addressParts = [];

  if (city) addressParts.push(city);
  if (state) addressParts.push(state);
  if (zip) addressParts.push(zip);
  if (country) addressParts.push(country);

  return addressParts.join(", ");
};

export default formatAddress;
